import React from 'react'
import AppFooter from './Footer/footer';

const AppLayout = ({chieldren}) => {
  return (
    <>
    <section>
      <main>
        {chieldren}
      </main>
      <br/>
      <br/>
      <footer id="footer">
        <AppFooter />
      </footer>
      </section>
    </>
  )
}

export default AppLayout
